var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8981 16H10.7969C7.33827 16 5.67127 14.6368 5.38306 11.5833C5.3519 11.2639 5.58559 10.9757 5.91275 10.9445C6.23213 10.9133 6.52035 11.1548 6.55151 11.4742C6.77741 13.9202 7.93028 14.8315 10.8047 14.8315H10.9059C14.0763 14.8315 15.1981 13.7098 15.1981 10.5394V5.46056C15.1981 2.29017 14.0763 1.16845 10.9059 1.16845H10.8047C7.9147 1.16845 6.76183 2.09542 6.55151 4.58812C6.51256 4.9075 6.24771 5.14898 5.91275 5.11782C5.58559 5.09445 5.3519 4.80623 5.37527 4.48685C5.64012 1.38656 7.3149 0 10.7969 0H10.8981C14.7229 0 16.3587 1.63583 16.3587 5.46056V10.5394C16.3587 14.3642 14.7229 16 10.8981 16Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6173 8.58425H0.584226C0.264849 8.58425 0 8.3194 0 8.00003C0 7.68065 0.264849 7.4158 0.584226 7.4158H10.6173C10.9367 7.4158 11.2016 7.68065 11.2016 8.00003C11.2016 8.3194 10.9445 8.58425 10.6173 8.58425Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8801 11.1938C8.7321 11.1938 8.58409 11.1393 8.46725 11.0225C8.24135 10.7966 8.24135 10.4227 8.46725 10.1968L10.6639 8.00008L8.46725 5.80339C8.24135 5.57749 8.24135 5.20358 8.46725 4.97768C8.69315 4.75178 9.06705 4.75178 9.29295 4.97768L11.9025 7.58723C12.1284 7.81313 12.1284 8.18703 11.9025 8.41293L9.29295 11.0225C9.17611 11.1393 9.0281 11.1938 8.8801 11.1938Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.d04edd6fbb8a89b4592316ac2fa6941e.svg";
export { ForwardRef as ReactComponent };